import { DefectType } from 'src/lib/fliko/models/defects/defect-settings.data';
import { ServiceUserData } from 'src/lib/fliko/models/users/user.data';
import { FileInStorageVM } from 'src/app/shared/models/file.data';

export enum ContractStatus {
  /** contract exists and is active (duh!) */
  ACTIVE = 'active',
  /** subcontractor has no contracts (yet) */
  INACTIVE = 'inactive',
  /** contract exists and ended */
  ENDED = 'ended',
  /** subcontractor is archived */
  ARCHIVED = 'archived'
}

export interface CompanyContractsVM {
  bySub: ContractsVM[];
  byEstate: ContractsVM[];
}

export interface ContractsVM {
  id: string;
  name: string;
  contracts: CompanyContract[];
}

export interface CompanyContract {
  /** subcontractorId for estate and estateId for subcontractors */
  id: string;
  /** For estate: local subName, for sub: estateName */
  name: string;
  /** For estate: global subName, For sub: local subName */
  otherName: string | null;
  /** For estate: subcontractor nip, For sub: null */
  NIP: string | null;
  startDate: number;
  endDate: number;
  noticeTime: number | null;
  value: number;
  currency: string;
  serviceUsers: ServiceUserData[];
  status: ContractStatus;
  attachments: FileInStorageVM[];
  types: DefectType[];
}
